<template>
	<div class="circle-t-tools">
		<div class="circle-t-view">
			<div class="circle-tv-emoji" v-if="emojiShow">
				<emoji key='c-t-1' @emoji-call="emojiCall($event)"></emoji>
			</div>
			<div class="circle-tv-pic" v-if="tType == 1">
				<oss-img-uploader maxPic = '9' uploadType="2" uploadDir="moments" key="circle-tools-u1" @oss-upload-call="ossUploadCall($event,'image')" v-if="showUploadComp"></oss-img-uploader>
				<div class="circle-tvp-preview" v-else-if="uploadedFiles.length > 0 && !showUploadComp">
					<div class="circle-tvp-item" v-for="(image,index) in uploadedFiles">
						<img :src="image" alt="">
						<span @click="deleteFile(index)">X</span>
					</div>
				</div>
			</div>
			<div class="circle-tv-video" v-else-if="tType == 2">
				<div class="circle-tvv-upload">
					<oss-img-uploader uploadType="1" uploadDir="moments" key="circle-tools-u2" @oss-upload-call="ossUploadCall($event,'videoPic')" v-if="showUploadComp"></oss-img-uploader>
					<div class="circle-tvvu-preview-img" v-else-if="videoPic.length > 0 && !showUploadComp">
						<img :src="videoPic[0]" alt="">
						<p>视频首图</p>
					</div>
				</div>
				<div class="circle-tvv-upload">
					<oss-img-uploader uploadType="3" uploadDir="moments" key='circle-tools-u3' @oss-upload-call="ossUploadCall($event,'video')" v-if="showUploadComp"></oss-img-uploader>
					<div class="circle-tvvu-preview-video" v-else-if="uploadedFiles.length > 0 && !showUploadComp">
						<video :src="uploadedFiles[0]" controls=""></video>
						<p>视频文件</p>
					</div>
				</div>
			</div>
			<div class="circle-tv-link" v-else-if="tType == 3">
				<div class="circle-tvl-item">
					<label>链接地址：</label>
					<input type="text" v-model="link">
				</div>
				<div class="circle-tvl-item">
					<label>链接内容：</label>
					<input type="text" v-model="linkText">
				</div>
				<div class="circle-tvl-item" style="height: auto;">
					<label>链接配图：</label>
					<oss-img-uploader uploadType="1" uploadDir="moments" key="circle-tools-u4" @oss-upload-call="ossUploadCall($event,'image')" v-if="showUploadComp"></oss-img-uploader>
					<div class="circle-tvl-preview" v-else-if="uploadedFiles.length > 0 && !showUploadComp">
						<img :src="uploadedFiles[0]" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="circle-t-tools-container">
			<div class="circle-t-tools-items">
				<div class="circle-t-tools-item">
					<span class="circle-t-tools-emoji" @click="showEmoji"></span>
				</div>
				<div class="circle-t-tools-item">
					<span class="circle-t-tools-image" @click="tabClick(1)"></span>
				</div>
				<div class="circle-t-tools-item">
					<span class="circle-t-tools-video" @click="tabClick(2)"></span>
				</div>
				<div class="circle-t-tools-item">
					<span class="circle-t-tools-link" @click="tabClick(3)"></span>
				</div>
				<div class="circle-t-tools-item">
					<span class="circle-t-tools-cancel" @click="tabClick(0)"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import OssImgUploader from '../../components/uploader/OssImgUploader.vue'
	import Emoji from '../../components/Emoji.vue'
	
	export default{
		 name: 'CircleTools',
		 components:{
			 OssImgUploader,
			 Emoji
		 },
		 props:{
			inputFocus:{
				type:Number,
				default:0
			} ,
			circleTemp:{
				type: Object,
				default: {}
			}
		 },
		 data(){
			 return {
				 uploadedFiles:[],
				 videoPic:[],
				 tType: 0,
				 emojiShow:false,
				 link: 'http://',
				 linkText:'',
				 isSendBack: false,
				 showUploadComp: true
			 }
		 },
		 methods:{
			 // 数据初始化
			 init(){
			 	this.uploadedFiles = []
			 	this.videoPic = []
			 	this.tType = 0
			 	this.emojiShow = false
			 	this.link =  'http://'
			 	this.linkText = ''
			 },
			 
			 // tab点击，除了表情
			tabClick(val){
				this.tType = val
				this.showUploadComp = true
				if(val == 0){
					this.tType = 0
					this.init()
				}
				this.$emit('circle-tools-call',this.getNormalFile())
			},
			
			// tab点击，emoji点击
			showEmoji(){
				this.emojiShow = !this.emojiShow
			},
			
			// emoji点击回调
			emojiCall(emoji){
				this.$emit('emoji-call',emoji)
			},
			
			// 文件上传监听
			ossUploadCall(data,type){
				if(type === 'image'){
					this.uploadedFiles = data
				}else if(type === 'video'){
					this.uploadedFiles = data
				}else if(type === 'videoPic'){
					this.videoPic = data
				}
				this.$emit('circle-tools-call',this.getNormalFile())
			},
			
			// 删除文件事件
			deleteFile(index){
				this.uploadedFiles.splice(index,1)
				this.$emit('circle-tools-call',this.getNormalFile())
			},
			
			// 过滤文件，返回原来文件
			getNormalFile(){
				 let data = {
					 tType: this.tType,
					 link: this.link,
					 linkText: this.linkText
				 }
				 let uploadedFiles = []
				 let videoPic = []
				 for (let i = 0; i < this.uploadedFiles.length; i++) {
					let file = this.uploadedFiles[i].split("?x-oss-process")
					if(file.length > 0 && file[0] !== ""){
						uploadedFiles.push(file[0])
					}
				 }
				 for (let i = 0; i < this.videoPic.length; i++) {
					let file = this.videoPic[i].split("?x-oss-process")
						if(file.length > 0 && file[0] !== ""){
							videoPic.push(file[0])
						}
				 }
				 data.uploadedFiles = uploadedFiles
				 data.videoPic = videoPic
				 return data
			}
		 },
		 watch:{
			 // 监听输入框聚集
			 inputFocus(val){
				 if(val == 1){
					 this.emojiShow = 0
				 }
			 },
			 
			 // 监听链接变化
			 link(val){
				 this.$emit('circle-tools-call',this.getNormalFile())
			 },
			 
			 // 监听链接内容变化
			 linkText(val){
				 this.$emit('circle-tools-call',this.getNormalFile())
			 },
			 
			 // 监听朋友圈模板选择变化
			 circleTemp(nVal){
				 this.init()
				 if(nVal.id === undefined){
					 return
				 }
				 this.showUploadComp = false
				 // 图片朋友圈
				 if(nVal.type == 1){
					 this.tType = 1
					 this.uploadedFiles = nVal.img_thumb
				 }else if(nVal.type == 3){
					 this.tType = 2
					 this.videoPic.push(nVal.cover_thumb)
					 this.uploadedFiles.push(nVal.img_url)
				 }else if(nVal.type == 4){
					 this.tType = 3
					 this.uploadedFiles.push(nVal.img_thumb)
					 this.linkText = nVal.url_content
					 this.link = nVal.url
				 }
				 this.$emit('circle-tools-call',this.getNormalFile())
			 }
		 }
	}
</script>

<style scoped>
	.circle-t-tools{
		width: 100%;
		height: auto;
		position: relative;
		box-sizing: border-box;
	}
	.circle-t-tools .circle-t-view{
		width: 100%;
		height: auto;
		position: relative;
	}
	.circle-t-view .circle-tv-emoji{
		position: absolute;
		width: 405px;
		height: 180px;
		bottom: -2px;
		left: 5px;
		z-index: 10;
	}
	.circle-t-view .circle-tv-video{
		width: 100%;
		display: flex;
		justify-content: flex-start;
	}
	.circle-tv-video .circle-tvv-upload{
		min-width: 130px;
		max-width: 350px;
		height: auto;
	}
	.circle-t-view .circle-tv-link{
		padding: 5px 10px;
	}
	.circle-t-view .comp-u-container{
		margin-bottom: 0 !important;
	}
	.circle-tv-link .circle-tvl-item{
		height: 36px;
		line-height: 36px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.circle-tvl-item label{
		width: 70px;
		height: 36px;
		overflow: hidden;
	}
	.circle-tvl-item input{
		height: 20px;
		border-bottom: 1px solid #d0d0d0;
		flex-grow: 1;
		width: 0;
		color: #888888;
		font-size: 12px;
	}
	.circle-tvl-item input:focus{
		border-bottom: 1px solid #42B983;
	}
	.circle-tvl-item > div{
		margin: 0 !important;
	}
	.circle-tv-buttons .circle-tvb-info{
		height: 30px;
		line-height: 30px;
		margin: 0 5px;
	}
	.circle-t-tools .circle-t-tools-container{
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
	}
	.circle-t-tools-container .circle-t-tools-items{
		flex-grow: 1;
		width: 0;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
	}
	.circle-t-tools-items .circle-t-tools-item{
		width: 24px;
		height: 24px;
		padding: 13px 10px;
	}
	.circle-t-tools-item span{
		display: block;
		width: 24px;
		height: 24px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		cursor: pointer;
	}
	.circle-t-tools-emoji{
		background-image: url(../../assets/img/comp-c-tools-emoji.png);
	}
	.circle-t-tools-image{
		background-image: url(../../assets/img/comp-c-tools-image.png);
	}
	.circle-t-tools-video{
		background-image: url(../../assets/img/comp-c-tools-video.png);
	}
	.circle-t-tools-link{
		background-image: url(../../assets/img/link-bf-32.png);
		background-size: 25px 25px !important;
	}
	.circle-t-tools-cancel{
		background-image: url(../../assets/img/cancel-bf-32.png);
		background-size: 25px 25px !important;
	}
	.circle-tvp-preview{
		padding: 13px;
		padding-bottom: 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
	}
	.circle-tvp-preview .circle-tvp-item{
		width: 80px;
		height: 80px;
		overflow: hidden;
		margin: 2px;
		position: relative;
	}
	.circle-tvp-item img{
		width: 100%;
		height: 100%;
	}
	.circle-tvp-item span{
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		background-color: #ff1e1e;
		width: 16px;
		height: 16px;
		line-height: 16px;
		text-align: center;
		color: #FFFFFF;
		cursor: pointer;
		user-select: none;
		font-size: 12px;
	}
	.circle-tvvu-preview-img{
		max-width: 150px;
		overflow: hidden;
		padding: 15px;
	}
	.circle-tvvu-preview-img img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.circle-tvvu-preview-img p{
		height: 24px;
		line-height: 24px;
		text-align: center;
		background-color: #009688;
		color: #FFFFFF;
	}
	.circle-tvvu-preview-video{
		padding: 15px;
	}
	.circle-tvvu-preview-video video{
		display: block;
		outline: none;
		max-width: 320px;
		min-width: 50px;
		max-height: 400px;
	}
	.circle-tvvu-preview-video p{
		height: 24px;
		line-height: 24px;
		text-align: center;
		background-color: #009688;
		color: #FFFFFF;
	}
	.circle-tvl-preview img{
		width: 90px;
		height: 90px;
		overflow: hidden;
	}
</style>
